import api from './client';

export const getLegalTypes = () =>
  api.get('/legal/types').then(r => r.data);

export const getRequiredAtRegistration = () =>
  api.get('/legal/required-at-registration').then(r => r.data);

export const getRequiredAtPayment = () =>
  api.get('/legal/required-at-payment').then(r => r.data);

export const getLegalDocument = (slug) =>
  api.get(`/legal/${slug}`).then(r => r.data);

export const recordConsent = (data) =>
  api.post('/legal/consent', data).then(r => r.data);

export const getMyConsents = () =>
  api.get('/legal/consents/me').then(r => r.data);
